import { Field } from 'redux-form';

import { SelectField, TextField } from 'common/components/forms';

const AddressFormField = (props) => {
  const { element, schema, requiredFields } = props;
  let component = TextField;
  if (schema[element].type === 'array') {
    component = SelectField;
  }
  let optionArray;
  if (schema[element].array) {
    optionArray = schema[element].array.map((record) => ({
      value: record.value,
      option: record.name
    }));
    optionArray.unshift({ value: '', option: '' });
  }
  let required = false;
  if (requiredFields.find((field) => field.field === element)) {
    required = true;
  }
  return (
    <Field
      name={element}
      component={component}
      optionArray={optionArray}
      label={schema[element].label}
      key={element}
      normalize={schema[element].normalize}
      required={required}
      autocomplete={autocomplete[element]}
    />
  );
};

const autocomplete = {
  company: 'organization',
  address: 'address-line1',
  address2: 'address-line2',
  city: 'address-level2',
  stateCode: 'address-level1',
  zipCode: 'postal-code'
};

export default AddressFormField;
